import type { CombinedError, Operation } from 'urql';
import { errorExchange } from 'urql';

import type { ErrorHandlerReference } from '../UrqlProvider';

/**
 * This allows tracking mutation errors through a reference.
 * This reference will later be loaded with a telemetry handler.
 * @see apps/order/src/context/Urql/hooks/useRegisterUrqlErrorTracker/useRegisterUrqlErrorTracker.ts
 * @see https://formidable.com/open-source/urql/docs/advanced/authoring-exchanges/#using-exchanges
 */
export const errorTrackingExchange = (
  errorHandlerReference: ErrorHandlerReference,
) =>
  errorExchange({
    onError(error: CombinedError, operation: Operation) {
      errorHandlerReference.current(error, operation);
    },
  });
